import { RouteLocation, RouteRecordRaw, RouterView } from 'vue-router';

/**
 * Returns a boolean indicating whether a route has a match and does not include server-rendered content (ex: a Django page)
 */
export function isVueRoute(route: RouteLocation): boolean {
  if (
    typeof route.meta?.hasServerRenderedContent === 'function'
      ? route.meta.hasServerRenderedContent()
      : route.meta?.hasServerRenderedContent
  ) {
    return false;
  }

  return !!route.matched.length;
}

/**
 * Transforms a route config to a non-Vue route config
 * @param route - a route config object
 */
export function toNonVueRoute(route): RouteRecordRaw {
  return {
    ...route,
    component: RouterView,
    meta: {
      ...route.meta,
      hasServerRenderedContent: true,
    },
  };
}
